module.exports = __webpack_public_path__ + "static/img/juliasexton_circle150.8c49a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/juliasexton_circle150.png
// module id = VJSH
// module chunks = 0